import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from '../../context/ThemeContext';
import styles from './PageHeader.module.scss';

const PageHeader = ({
  title,
  subtitle,
  actionButton,
  backButton,
  onBackClick,
  className = '',
  children
}) => {
  const { isDarkMode } = useTheme();

  const muiTheme = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: '#e36250 !important',
      },
      secondary: {
        main: '#8b5cf6',
      },
    },
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <Box className={`${styles.header} ${className}`}>
        <Box className={styles.headerContent}>
          <Box className={styles.headerLeft}>
            {backButton && (
              <IconButton 
                onClick={onBackClick}
                className={styles.backButton}
                size="large"
              >
                {backButton}
              </IconButton>
            )}
            <Box className={styles.titleSection}>
              <Typography variant="h5" className={styles.headerTitle}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" className={styles.headerSubtitle}>
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
          <Box className={styles.headerRight}>
            {actionButton}
            {children}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default PageHeader;
